<template>
  <div id="Admin">
    <nav class="topnav navbar navbar-expand shadow navbar-light bg-white" id="sidenavAccordion">
      <router-link to="/admin" class="navbar-brand d-sm-block">
        <img :src="client.logo" style="height: 30px" alt class="mr-1" />
        <!-- {{ client.shortName }} -->
      </router-link>
      <button @click="showSideShow" class="btn btn-icon btn-transparent-dark order-1 order-lg-0 mr-lg-2" id="sidebarToggle">
        <i class="fas fa-bars"></i>
      </button>
      <!-- Search form -->
      <!-- <form @submit.prevent="searchHandle" class="form-inline mr-auto d-none d-lg-block">
        <input class="form-control form-control-solid mr-sm-2" type="search" placeholder="Search" aria-label="Search" />
      </form>-->
      <!-- right memu -->
      <ul class="navbar-nav align-items-center ml-auto">
        <li class="nav-item dropdown no-caret mr-3 dropdown-user">
          <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="img-fluid" :src="authUser.photo" style="width: 60px" />
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
            <h6 class="dropdown-header d-flex align-items-center">
              <img class="dropdown-user-img" :src="authUser.photo" />
              <div class="dropdown-user-details">
                <div class="dropdown-user-details-name">{{ authUser.name }}</div>
                <div class="dropdown-user-details-email">{{ authUser.email }}</div>
              </div>
            </h6>
            <div class="dropdown-divider"></div>
            <!-- <a class="dropdown-item" href="#!">
              <div class="dropdown-item-icon">
                <i data-feather="settings"></i>
              </div>Account
            </a>-->
            <router-link class="dropdown-item" :to="{ name: 'UserProfileAdmin' }" style="cursor: pointer">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              Profile
            </router-link>

            <!-- Logout menu -->
            <Logout type="menu"></Logout>
          </div>
        </li>
      </ul>
    </nav>

    <div id="layoutSidenav">
      <!-- side menue -->
      <div id="layoutSidenav_nav">
        <nav class="sidenav shadow-right sidenav-light">
          <div class="sidenav-menu">
            <div class="nav accordion" id="accordionSidenav">
              <div class="sidenav-menu-heading">Core</div>
              <router-link to="/admin" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                Dashboard
              </router-link>

              <a class="nav-link" href="javascript:void(0);" data-toggle="collapse" data-target="#collapseTickets" aria-expanded="false" aria-controls="collapseTickets">
                <div class="nav-link-icon">
                  <i class="fas fa-headset"></i>
                </div>
                Tickets
                <div class="sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div class="collapse show" id="collapseTickets" data-parent="#accordionSidenav">
                <nav class="sidenav-menu-nested nav accordion" id="accordionSidenavPages">
                  <router-link to="/admin/tickets/open" class="nav-link">Open</router-link>
                  <router-link to="/admin/tickets/escalated" class="nav-link">Escalated</router-link>
                  <router-link to="/admin/tickets/closed" class="nav-link">Closed</router-link>
                  <router-link to="/admin/tickets/all" class="nav-link">All</router-link>
                  <router-link to="/admin/my-tickets" class="nav-link">My</router-link>
                  <router-link :to="{ name: 'CreateTicketAdmin' }" class="nav-link">Create</router-link>
                </nav>
              </div>

              <router-link to="/admin/faqs" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="fas fa-chart-line"></i>
                </div>
                FAQs
              </router-link>

              <div class="sidenav-menu-heading">Environment</div>

              <a class="nav-link collapsed" href="javascript:void(0);" data-toggle="collapse" data-target="#collapseTopCategory" aria-expanded="false" aria-controls="collapseTopCategory">
                <div class="nav-link-icon">
                  <i class="fas fa-sitemap"></i>
                </div>
                {{ client.topCategoryLabel | pluralize }}
                <div class="sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div class="collapse" id="collapseTopCategory" data-parent="#accordionSidenav">
                <nav class="sidenav-menu-nested nav accordion" id="accordionSidenavPages">
                  <router-link :to="{ name: 'CreateCategoryAdmin' }" class="nav-link">Create</router-link>
                  <router-link :to="{ name: 'CategoriesAdmin' }" class="nav-link">View</router-link>
                </nav>
              </div>

              <a class="nav-link collapsed" href="javascript:void(0);" data-toggle="collapse" data-target="#collapseSubCategory" aria-expanded="false" aria-controls="collapseSubCategory">
                <div class="nav-link-icon">
                  <i class="far fa-folder-open"></i>
                </div>
                {{ client.subCategoryLabel | pluralize }}
                <div class="sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div class="collapse" id="collapseSubCategory" data-parent="#accordionSidenav">
                <nav class="sidenav-menu-nested nav accordion" id="accordionSidenavPages">
                  <router-link :to="{ name: 'CreateSubCategoryAdmin' }" class="nav-link">Create</router-link>
                  <router-link :to="{ name: 'SubCategoriesAdmin' }" class="nav-link">View</router-link>
                </nav>
              </div>

              <a class="nav-link collapsed" href="javascript:void(0);" data-toggle="collapse" data-target="#collapseCustomeRole" aria-expanded="false" aria-controls="collapseCustomeRole">
                <div class="nav-link-icon">
                  <i class="far fa-folder-open"></i>
                </div>
                Custom Roles
                <div class="sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div class="collapse" id="collapseCustomeRole" data-parent="#accordionSidenav">
                <nav class="sidenav-menu-nested nav accordion" id="accordionSidenavPages">
                  <router-link :to="{ name: 'CreateCustomRoleAdmin' }" class="nav-link">Create</router-link>
                  <router-link :to="{ name: 'CustomRolesAdmin' }" class="nav-link">View</router-link>
                </nav>
              </div>

              <a class="nav-link collapsed" href="javascript:void(0);" data-toggle="collapse" data-target="#collapseUsers" aria-expanded="false" aria-controls="collapseUsers">
                <div class="nav-link-icon">
                  <i class="fas fa-users"></i>
                </div>
                Users
                <div class="sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div class="collapse" id="collapseUsers" data-parent="#accordionSidenav">
                <nav class="sidenav-menu-nested nav accordion" id="accordionSidenavPages">
                  <router-link to="/admin/users/agent" class="nav-link">{{ client.agentLabel | pluralize }}</router-link>
                  <router-link to="/admin/users/supervisor" class="nav-link">{{ client.supervisorLabel | pluralize }}</router-link>
                  <router-link to="/admin/users/admin" class="nav-link">Admins</router-link>
                  <router-link to="/admin/users/custom" class="nav-link">Custom</router-link>
                  <router-link to="/admin/user/create" class="nav-link">Create new user</router-link>
                </nav>
              </div>

              <div class="sidenav-menu-heading">Billing</div>
              <router-link to="/admin/billing/transactions" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="far fa-chart-bar"></i>
                </div>
                Transactions
              </router-link>
              <!-- <router-link to="/admin/billing/payment-method" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="far fa-credit-card"></i>
                </div>Payment Method
              </router-link>-->
              <!-- <router-link to="/admin/billing/renew" class="nav-link collapsed" data-toggle="collapse" data-target="#collapseDashboards" aria-expanded="false" aria-controls="collapseDashboards">
                <div class="nav-link-icon">
                  <i class="far fa-money-bill-alt"></i>
                </div>Renew
              </router-link>-->
            </div>
          </div>
          <div class="sidenav-footer">
            <div class="sidenav-footer-content">
              <div class="sidenav-footer-subtitle">Logged in as:</div>
              <div class="sidenav-footer-title">{{ authUser.name }}</div>
              <!-- Logout link -->
              <Logout type="link"></Logout>
            </div>
          </div>
        </nav>
      </div>

      <div id="layoutSidenav_content">
        <!-- main content -->
        <router-view />

        <!-- footer -->
        <footer class="footer mt-auto footer-light">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 small">{{ copyright }}</div>
              <div class="col-md-6 text-md-right small">
                Powered by
                <a href="https://coregrade.co" target="_blank">Coregrade</a>
              </div>
            </div>
          </div>
        </footer>
        <!-- footer -->
      </div>
    </div>
  </div>
</template>

<script>
import Logout from "@/components/Logout.vue";

export default {
  name: "Admin",

  data() {
    return {
      sideMenuDisplayStatus: true,
    };
  },

  mounted() {
    this.$store.dispatch("getClient");
  },

  computed: {
    client() {
      let client = this.$store.state.client;
      if (client.name == "") {
        this.$router.push({ name: "AccountNotFound" });
      }
      return client;
    },

    authUser() {
      return this.$store.state.authUser;
    },

    copyright() {
      let d = new Date();
      return `Copyright ©${d.getFullYear()} ${this.$store.state.client.shortName}`;
    },
  },

  methods: {
    showSideShow() {
      let body = document.body;
      this.sideMenuDisplayStatus = !this.sideMenuDisplayStatus;
      if (!this.sideMenuDisplayStatus) {
        body.classList.add("sidenav-toggled");
      } else {
        body.classList.remove("sidenav-toggled");
      }
    },

    searchHandle() {
      this.$router.push({
        name: "Search",
        params: { query: this.searchQuery },
      });
      this.searchQuery = "";
      this.searchFormStatus = false;
    },

    profile() {
      this.$router.push({ name: "UserProfileAdmin" });
    },
  },

  components: {
    Logout,
  },
};
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
.page-header-subtitle {
  margin-left: 10px !important;
}
/* #layoutSidenav #layoutSidenav_content {
  margin-left: 0;
} */
</style>
